export default __webpack_public_path__ + "static/nagios-4b6d1ec36b36141e7f9d01aebd689911.png";